var scope_0 = require('/opt/build/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/a7b5c322f49b78673cfae09ec663a35b.js').default;export default
        Object.assign({}, scope_0 )
    